import { ErrorHandler, Injectable } from "@angular/core";
import { AppInjector } from "../injector/injector.module";
import { APIGatewayService } from "../gateway/APIGateway.service";
import { ClientException } from "@base/entities/BaseEntities";
import { DeviceDetectorService } from 'ngx-device-detector';
import { SysGlobals } from "../framework/sysglobals";
import { environment } from "../../environment/environment";
import { NavigatorService } from "../framework/navigator.service";

@Injectable()
export class ExceptionHandler implements ErrorHandler {
    handleError(error) {
        //Error info
        var Exception = new ClientException;
        Exception.Message = error.message || error.toString();
        Exception.Type = error.name;
        Exception.StackTrace = error.stack;

        //Dispatch 'errorOccured' event
        //Syntax was adapted to work in the IE browser
        var event = document.createEvent('Event');
        event['errorMessage'] = Exception.Message;
        event.initEvent('errorOccured', true, true);
        document.dispatchEvent(event);

        SysGlobals.LastException = Exception;

        //Skip when debugging
        if (!environment.production) {
            console.error(error);
            throw (error);
        }

        //Print error
        console.error(error);

        //Device info
        var Detector = AppInjector.get(DeviceDetectorService);
        Exception.Device = Detector.device;
        Exception.DeviceType = (!Detector.isMobile() ? 'D' : (Detector.isMobile() ? 'M' : 'T'));
        Exception.Browser = Detector.browser;
        Exception.BrowserVersion = Detector.browser_version;
        Exception.OS = Detector.os;
        Exception.OSVersion = Detector.os_version;

        //Execute
        var api = AppInjector.get(APIGatewayService);
        api.ExecutePostAction("System", "LogClientException", Exception).subscribe(x => {
            var Navigator = AppInjector.get(NavigatorService);
            Navigator.Navigate(['/system/exception']);
            history.replaceState(null, null, '/system/exception') // replace last broken page url
        });
    }
}
